import PropTypes from 'prop-types';

function Flag({ code }) {
    return code === 'ru' ? (
        <svg className="flag" viewBox="0 0 28 18" aria-hidden="true">
            <path fill="#fff" d="M0 0h28v6H0z" />
            <path fill="#1c57a7" d="M0 6h28v6H0z" />
            <path fill="#d52b1e" d="M0 12h28v6H0z" />
        </svg>
    ) : (
        <svg className="flag" viewBox="0 0 28 18" aria-hidden="true">
            <path fill="#17365d" d="M0 0h28v18H0z" />
            <path stroke="#fff" strokeWidth="4" d="m0 0 28 18M28 0 0 18" />
            <path stroke="#cf2338" strokeWidth="2" d="m0 0 28 18M28 0 0 18" />
            <path stroke="#fff" strokeWidth="6" d="M14 0v18M0 9h28" />
            <path stroke="#cf2338" strokeWidth="3.2" d="M14 0v18M0 9h28" />
        </svg>
    );
}

Flag.propTypes = {
    code: PropTypes.oneOf(['ru', 'gb']).isRequired,
};

export default Flag;
